export const ReferralKeys = 'referral'
